import React, { useState, useEffect, useCallback } from 'react';
import { Users, MessageSquare, Image, Video } from 'lucide-react';
import { getConfig, getApiUrl } from '../config';
import './Statistics.css';

const Statistics = () => {
  const config = getConfig();
  const [stats, setStats] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const fetchStatistics = useCallback(async () => {
    try {
      setLoading(true);
      const response = await fetch(getApiUrl(config.api.endpoints.statistics));

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      const data = await response.json();

      if (!data.success || !data.data) {
        throw new Error('Invalid statistics response');
      }

      setStats(data.data);
    } catch (err) {
      setError(err.message);
    } finally {
      setLoading(false);
    }
  }, [config]);

  useEffect(() => {
    fetchStatistics();
  }, [fetchStatistics]);

  const formatDate = (dateString) => {
    try {
      const date = new Date(dateString);
      return date.toLocaleDateString(config.ui.locale, {
        year: 'numeric',
        month: 'long',
        day: 'numeric'
      });
    } catch {
      return dateString;
    }
  };

  if (loading) {
    return (
      <div className="statistics-container">
        <div className="loading-stats">
          <div className="spinner"></div>
          <p>Загрузка статистики...</p>
        </div>
      </div>
    );
  }

  if (error) {
    return (
      <div className="statistics-container">
        <div className="error-stats">
          <p>Ошибка загрузки статистики: {error}</p>
        </div>
      </div>
    );
  }

  if (!stats) {
    return null;
  }

  return (
    <div className="statistics-container">
      <h2>Статистика базы данных</h2>
      
      <div className="stats-grid">
        <div className="stat-card total-comments">
          <div className="stat-icon">
            <MessageSquare size={24} />
          </div>
          <div className="stat-content">
            <h3>Всего комментариев</h3>
            <p className="stat-value">{stats.total_comments.toLocaleString()}</p>
          </div>
        </div>

        <div className="stat-card total-authors">
          <div className="stat-icon">
            <Users size={24} />
          </div>
          <div className="stat-content">
            <h3>Уникальных авторов</h3>
            <p className="stat-value">{stats.total_authors.toLocaleString()}</p>
          </div>
        </div>

        <div className="stat-card comments-images">
          <div className="stat-icon">
            <Image size={24} />
          </div>
          <div className="stat-content">
            <h3>Комментариев с изображениями</h3>
            <p className="stat-value">{stats.comments_with_images.toLocaleString()}</p>
            <p className="stat-percentage">
              ({((stats.comments_with_images / stats.total_comments) * 100).toFixed(1)}%)
            </p>
          </div>
        </div>

        <div className="stat-card comments-videos">
          <div className="stat-icon">
            <Video size={24} />
          </div>
          <div className="stat-content">
            <h3>Комментариев с видео</h3>
            <p className="stat-value">{stats.comments_with_videos.toLocaleString()}</p>
            <p className="stat-percentage">
              ({((stats.comments_with_videos / stats.total_comments) * 100).toFixed(1)}%)
            </p>
          </div>
        </div>

        {/* Временно закомментировано
        <div className="stat-card avg-rating-plus">
          <div className="stat-icon">
            <TrendingUp size={24} />
          </div>
          <div className="stat-content">
            <h3>Средний рейтинг +</h3>
            <p className="stat-value">{stats.avg_rating_plus.toFixed(1)}</p>
          </div>
        </div>

        <div className="stat-card avg-rating-minus">
          <div className="stat-icon">
            <TrendingDown size={24} />
          </div>
          <div className="stat-content">
            <h3>Средний рейтинг -</h3>
            <p className="stat-value">{stats.avg_rating_minus.toFixed(1)}</p>
          </div>
        </div>
        */}
      </div>

      <div className="stats-timeline">
        <div className="timeline-item">
          <h4>Самый старый комментарий</h4>
          <p>{formatDate(stats.oldest_comment)}</p>
        </div>
        <div className="timeline-item">
          <h4>Самый новый комментарий</h4>
          <p>{formatDate(stats.newest_comment)}</p>
        </div>
      </div>
    </div>
  );
};

export default Statistics; 